import * as effects from './alert.effects';

export const alertEffects: any[] = [effects.AlertEffects];

export * from './alert.actions';
export * from './alert.effects';
